// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__G-Vme","label":"Input_label__eFwk7","input":"Input_input__eInH8","light":"Input_light__syLFS","dark":"Input_dark__Qpg7l"};